export const MERCHANT_STATUS = { ACTIVE: 'active', INACTIVE: 'inactive' };
